import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import styles from './style.module.css';

const PaginationButtons = ({ page, totalPages, setPage, onPageChange }) => {
  const handlePageChange = (newPage) => {
    if (newPage > page) {
      onPageChange(newPage, 'next');
    } else {
      onPageChange(newPage, 'prev');
    }
  };

  return (
    <div className={styles.subTitleContainer}>
      <div className={styles.buttonContainer}>
        <div
          className={`${styles.button} ${page === 0 ? styles.disabled : ''}`}
          onClick={() => page > 0 && handlePageChange(page - 1)}>
          <ReactSVG
            src={Icons.leftArrow}
            className={styles.buttonArrow}
            beforeInjection={(svg) => {
              svg.querySelectorAll('path').forEach((path) => {
                path.setAttribute('stroke', page === 0 ? '#CACFD8' : '#131517');
              });
            }}
          />
          <span style={{ color: page === 0 ? '#CACFD8' : '#131517' }}>
            Prev
          </span>
        </div>
        <div
          className={`${styles.button} ${
            page >= totalPages - 1 ? styles.disabled : ''
          }`}
          onClick={() => page < totalPages - 1 && handlePageChange(page + 1)}>
          <span
            style={{
              color: page >= totalPages - 1 ? '#CACFD8' : '#131517',
            }}>
            Next
          </span>
          <ReactSVG
            src={Icons.rightArrow}
            className={styles.buttonArrow}
            beforeInjection={(svg) => {
              svg.querySelectorAll('path').forEach((path) => {
                path.setAttribute(
                  'stroke',
                  page >= totalPages - 1 ? '#CACFD8' : '#131517'
                );
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PaginationButtons;
